import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

// Apply theme class to <html> BEFORE React renders to prevent FOUC
// (flash of unstyled content). Reads the same key used by the theme store.
(function applyInitialTheme() {
  let theme: "light" | "dark" = "dark";
  try {
    const saved = localStorage.getItem("livecharts:theme");
    if (saved === "light" || saved === "dark") theme = saved;
  } catch {
    /* ignore */
  }
  document.documentElement.classList.add(theme);
})();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
